/* GIST LIBRARY — The Gist Journal (articles, gxr-*)
   Topic filter: an accessible tablist over the article rows.
   Dependency-free · idempotent · reduced-motion safe · no-JS fallback shows all rows.
   Cloned from gist-audiosummaries.js (root .gxr-stream, guard __gxrLoaded). */
(function () {
  'use strict';
  if (window.__gxrLoaded) return;
  window.__gxrLoaded = true;

  var uid = 0;

  function once(el) {
    if (el.hasAttribute('data-gxr-init')) return false;
    el.setAttribute('data-gxr-init', '1');
    return true;
  }

  function initStream(root) {
    (root || document).querySelectorAll('.gxr-stream').forEach(function (sec) {
      if (!once(sec)) return;

      var pillsWrap = sec.querySelector('.gxa-filter__pills');
      var pills = Array.prototype.slice.call(sec.querySelectorAll('.gxa-pill'));
      var grid = sec.querySelector('.gxa-grid');
      var slots = Array.prototype.slice.call(sec.querySelectorAll('.gxa-slot'));
      var status = sec.querySelector('.gxa-filter__status');

      /* Missing pieces -> leave the no-JS view (all rows visible, pills hidden). */
      if (!pillsWrap || !pills.length || !grid || !slots.length) return;

      sec.classList.add('gxa-js');
      grid.id = grid.id || ('gxr-grid-' + (++uid));

      pillsWrap.setAttribute('role', 'tablist');
      grid.setAttribute('role', 'region');
      grid.setAttribute('aria-label', 'Articles');

      pills.forEach(function (pill, i) {
        pill.setAttribute('role', 'tab');
        pill.setAttribute('aria-controls', grid.id);
        pill.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        pill.tabIndex = i === 0 ? 0 : -1;
      });

      function apply(topic) {
        var shown = 0;
        slots.forEach(function (s) {
          var have = ' ' + (s.getAttribute('data-topic') || '') + ' ';
          var on = !topic || have.indexOf(' ' + topic + ' ') > -1;
          s.hidden = !on;
          if (on) shown++;
        });
        if (status) {
          status.textContent = topic
            ? ('Showing ' + shown + ' of ' + slots.length)
            : ('Showing all ' + slots.length);
        }
      }

      function select(idx, focus) {
        pills.forEach(function (p, i) {
          var on = i === idx;
          p.setAttribute('aria-selected', on ? 'true' : 'false');
          p.tabIndex = on ? 0 : -1;
        });
        apply(pills[idx].getAttribute('data-topic') || '');
        if (focus) pills[idx].focus();
      }

      pills.forEach(function (pill, i) {
        pill.addEventListener('click', function () { select(i, false); });
        pill.addEventListener('keydown', function (ev) {
          var to = null;
          if (ev.key === 'ArrowRight' || ev.key === 'ArrowDown') to = (i + 1) % pills.length;
          if (ev.key === 'ArrowLeft' || ev.key === 'ArrowUp') to = (i - 1 + pills.length) % pills.length;
          if (ev.key === 'Home') to = 0;
          if (ev.key === 'End') to = pills.length - 1;
          if (to === null) return;
          ev.preventDefault();
          select(to, true);
        });
      });

      apply('');   /* initial state: All */
    });
  }

  function initAll(root) { initStream(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
